import React, { useState } from 'react';
import { useMap, useMapEvents } from '@manifesto-tech/react-leaflet';
import CenterPopup from './CenterPopup.jsx';
import { decodeHTMLEntities } from '../utils/utilities';

const Card = ({ type, image, name, description, linkText, linkUrl, position }) => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  const [center, setCenter] = useState(map.getCenter());
  const directions = `https://www.google.com/maps/dir//${position.join(',')}/@${center.lat},${
    center.lng
  },${zoom}z`;

  useMapEvents({
    zoom({ target }) {
      setZoom(target.getZoom());
      setCenter(target.getCenter());
    },
    drag({ target }) {
      setCenter(target.getCenter());
    },
  });

  return (
    <CenterPopup className="font-sans">
      <div className="text-base">
        {image && (
          <div className="w-full">
            <img src={decodeHTMLEntities(image)} className="w-full h-full" />
          </div>
        )}
        <div className="p-4 md:p-6">
          {type && (
            <div
              className="mb-3 text-2xs lg:text-sm uppercase font-semibold tracking-widest text-grey"
              dangerouslySetInnerHTML={{ __html: type }}
            />
          )}
          {name && (
            <h3
              className="text-h3 text-black font-medium mb-4"
              dangerouslySetInnerHTML={{ __html: name }}
            />
          )}
          {description && (
            <div
              className="o-map__card-description prose prose-inherit max-sm:text-sm lg:text-lg text-grey"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {directions && (
            <a
              className={[
                'o-map__card-link',
                'o-map__card-link--directions',
                'a-button',
                'a-button--secondary',
                'a-button--grey',
                'mb-2.5',
              ].join(' ')}
              href={directions}
              target="_blank"
              rel="noreferrer"
            >
              Get directions
            </a>
          )}
          {linkUrl && linkText && (
            <a
              className="o-map__card-link a-button a-button--primary a-button--grey"
              href={linkUrl}
            >
              {linkText}
            </a>
          )}
        </div>
      </div>
    </CenterPopup>
  );
};

export default Card;
